import { render, staticRenderFns } from "./picksamples.vue?vue&type=template&id=b9950474&"
import script from "./picksamples.vue?vue&type=script&lang=js&"
export * from "./picksamples.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports